if (!customElements.get('mox-shipping-offers')) {
  customElements.define('mox-shipping-offers', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const opener = this.querySelector('.mox-shipping-offers__open');
      const dialog = this.querySelector('dialog');
      const pause = this.querySelector('.mox-shipping-offers__pause');
      if (!opener || !dialog || !pause) return;
      let returnFocus = null;
      const reset = () => {
        opener.setAttribute('aria-expanded', 'false');
        if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
        returnFocus = null;
      };
      if (typeof dialog.showModal === 'function') {
        opener.hidden = false;
        this.querySelector('.mox-shipping-offers__fallback').hidden = true;
        opener.addEventListener('click', () => {
          returnFocus = document.activeElement;
          if (!dialog.open) dialog.showModal();
          opener.setAttribute('aria-expanded', 'true');
        }, options);
        this.querySelector('.mox-shipping-offers__close').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('close', reset, options);
        dialog.addEventListener('cancel', () => { dialog.close(); }, options);
        let backdropDown = false;
        dialog.addEventListener('pointerdown', event => { backdropDown = event.target === dialog; }, options);
        dialog.addEventListener('click', event => {
          if (backdropDown && event.target === dialog) dialog.close();
          backdropDown = false;
        }, options);
      }
      pause.hidden = false;
      pause.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        pause.setAttribute('aria-pressed', String(paused));
        pause.setAttribute('aria-label', paused ? pause.dataset.resumeLabel : pause.dataset.pauseLabel);
        pause.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
      }, options);
      this.cleanup = () => { if (dialog.open) dialog.close(); controller.abort(); };
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
  });
}
